import isArrayBuffer from 'lodash/isArrayBuffer';

const getArrayBufferFromFile = (file: File): Promise<ArrayBuffer> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsArrayBuffer(file);

    reader.onload = () => {
      if (isArrayBuffer(reader.result)) {
        resolve(reader.result);
      } else {
        reject();
      }
    };

    reader.onerror = () => {
      reader.abort();
      reject();
    };
  });

export default getArrayBufferFromFile;
